// etx_ui.js

// Utility: Fade in — sets display:block, then transitions opacity 0→1
function fadeIn(element, duration = 250) {
  if (!element) return;

  // Cancel any running hide
  if (element._hideHandler) {
    element.removeEventListener('transitionend', element._hideHandler);
    element._hideHandler = null;
  }

  // Already fully visible — skip (inline style check avoids forced reflow)
  if (element.style.display !== 'none' && element.style.opacity === '1') return;

  element.style.transition = 'none';
  element.style.display = 'block';
  element.style.opacity = '0';

  // Double rAF: ensures display:block is painted before transition starts
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      element.style.transition = `opacity ${duration}ms ease`;
      element.style.opacity = '1';
    });
  });
}

// Utility: Fade out — transitions opacity 1→0, then sets display:none
function hide(element, duration = 250) {
  if (!element) return;

  if (element._hideHandler) {
    element.removeEventListener('transitionend', element._hideHandler);
    element._hideHandler = null;
  }

  // Already hidden — transitionend would never fire (inline style check avoids forced reflow)
  if (element.style.display === 'none') return;

  element.style.transition = `opacity ${duration}ms ease`;
  element.style.opacity = '0';

  const onEnd = (event) => {
    if (event.target !== element || event.propertyName !== 'opacity') return;
    element.style.display = 'none';
    element.style.transition = '';
    element.removeEventListener('transitionend', onEnd);
    element._hideHandler = null;
  };

  element._hideHandler = onEnd;
  element.addEventListener('transitionend', onEnd);
}

// Utility: Instant hide without animation (use before fadeIn to avoid compound opacity)
function instantHide(element) {
  if (!element) return;
  if (element._hideHandler) {
    element.removeEventListener('transitionend', element._hideHandler);
    element._hideHandler = null;
  }
  element.style.transition = 'none';
  element.style.opacity = '0';
  element.style.display = 'none';
}

function show(element) {
  fadeIn(element);
}

// Hero-Videos erst nach dem Load-Event starten (Poster bleibt LCP)
function startDeferredVideos() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  if (reduceMotion || saveData) return;

  const isMobile = window.matchMedia('(max-width: 767px)').matches;

  document.querySelectorAll('video[data-etx-defer-video]').forEach((video) => {
    if (video.dataset.etxStarted) return;
    // Mobile: nur abspielen, wenn eine eigene Mobile-Quelle existiert, sonst bleibt das Poster stehen
    // Ohne Mobile-Fassung nur bei schneller Verbindung das grosse Video laden
    const conn = navigator.connection;
    const fastEnough = !conn || conn.effectiveType === '4g';
    if (isMobile && !video.querySelector('source[media][data-src]') && !fastEnough) return
    video.dataset.etxStarted = '1';

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
    video.load();
    video.play().catch(() => {});
  });
}

// Header-CardLinkSlider initialisieren, sobald ein Panel sichtbar ist
function refreshHeaderCardLinkSliders(elements) {
  if (typeof window.etxInitOrRefreshCardLinkSliders !== "function") return;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.etxInitOrRefreshCardLinkSliders(elements);
    });
  });

  setTimeout(() => {
    window.etxInitOrRefreshCardLinkSliders(elements);
  }, 300);
}

// Update Cart Bubble
function updateCartBubble(increment = 1) {
  const bubbles = document.querySelectorAll(".cart-count-bubble");
  if (!bubbles.length) return;

  bubbles.forEach((bubble) => {
    const countEl = bubble.querySelector('span[aria-hidden="true"]');
    const hiddenEl = bubble.querySelector(".visually-hidden");

    if (!countEl || !hiddenEl) return;

    const currentCount = parseInt(countEl.textContent.trim(), 10) || 0;
    const newCount = currentCount + increment;

    countEl.textContent = newCount;
    hiddenEl.textContent = `${newCount} Artikel`;

    bubble.classList.remove("hidden");
  });
}

// Add variant to cart
async function addToCart(button) {
  const variantId = button.dataset.variantId;
  const originalText = button.innerHTML;

  button.disabled = true;
  button.innerHTML = 'Wird hinzugefügt…';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Cart add error:', errorData);
      button.innerHTML = 'Fehler';
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 2000);
      return;
    }

    await response.json();

    button.innerHTML = 'Hinzugefügt';

    const drawer = document.querySelector(".drawer");
    setTimeout(() => {
      drawer?.refresh(true);
    }, 550);

    setTimeout(() => {
      button.innerHTML = originalText;
      button.disabled = false;
    }, 2000);
  } catch (error) {
    console.error('Network/cart error:', error);
    button.innerHTML = 'Fehler';
    setTimeout(() => {
      button.innerHTML = originalText;
      button.disabled = false;
    }, 2000);
  }
}


function closeNav() {
  const htmlElement = document.documentElement;
  const header = document.querySelector("header");

  htmlElement.classList.remove("nav-show");

  if (header) {
    header.removeAttribute("data-open");
  }

  document.querySelectorAll(".HeaderNav a, .HeaderNav span, .HeaderSearch a, .HeaderSearch span").forEach(el => {
    el.classList.remove("active");
  });

  document.querySelectorAll(".HeaderExpandable__inner").forEach(el => instantHide(el));
}

// Initialize App
document.addEventListener("DOMContentLoaded", function () {

  // Shopify Theme Editor Mode
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    const reinitSliders = () => {
      etxSwiper();
    };

    document.addEventListener("shopify:section:load", reinitSliders);
    document.addEventListener("shopify:section:load", startDeferredVideos);
    document.addEventListener("shopify:section:reorder", reinitSliders);
    document.addEventListener("shopify:section:unload", reinitSliders);
  }

  // Initialize Lenis Smooth Scroll
  if (typeof Lenis !== 'undefined') {
    window.lenis = new Lenis({
      smoothWheel: true,
      lerp: 0.075,
      wheelMultiplier: 1.25,
      autoResize: false
    });

    function raf(time) {
      if (!window.__lenisGsapTicker) {
        window.lenis.raf(time);
      }

      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    let resizeFrame = null;

    const resizeLenis = () => {
      if (resizeFrame !== null) {
        cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = null;
        window.lenis?.resize();
      });
    };

    window.addEventListener('load', resizeLenis);
    window.addEventListener('resize', resizeLenis);

    const resizeObserver = new ResizeObserver(resizeLenis);

    resizeObserver.observe(document.documentElement);
    resizeObserver.observe(document.body);

    document.addEventListener('shopify:section:load', resizeLenis);
    document.addEventListener('shopify:section:unload', resizeLenis);
    document.addEventListener('shopify:section:reorder', resizeLenis);

    window._etxResizeObserver = resizeObserver;
  }


  // Initialize Modules
  const selectors = {
    scrollytelling: '[data-module="ScrollytellingVision"]',
    accordion: '.Accordion',
    filter: '.FlexListingWithFilter',
    swiper: '.swiper',
    parallax: '.parallax'
  };

  // Defer heavy module inits out of DOMContentLoaded.
  // Disconnect MutationObserver during init so the hundreds of DOM mutations
  // from Swiper/ScrollTrigger don't each trigger a separate lenis.resize().
  requestAnimationFrame(async () => {
    if (window._etxMutationObserver) window._etxMutationObserver.disconnect();

    const yieldToMain = () => new Promise((resolve) => setTimeout(resolve, 0));

    const inits = [
      [selectors.swiper, () => etxSwiper()],
      [selectors.scrollytelling, () => etxScrollyTelling()],
      [selectors.accordion, () => etxAccordion()],
      [selectors.filter, () => etxFilter()],
      [selectors.parallax, () => etxParallax()],
    ];

    for (const [selector, init] of inits) {
      if (document.querySelector(selector)) {
        try {
          init();
        } catch (error) {
          console.error(`Init fehlgeschlagen für ${selector}:`, error);
        }
        await yieldToMain();
      }
    }

    if (typeof etxLazyLoad === 'function') etxLazyLoad();

    if (window._etxMutationObserver) {
      window._etxMutationObserver.observe(document.body, { childList: true, subtree: true });
    }
    // kein lenis.resize() hier – erledigt der ResizeObserver (vermeidet Forced Reflow)
  });

  /*** ALLGEMEIN ***/

  // Ankündigungleiste ganz oben einberechnen
  /*
  const announcementBar = document.querySelector(".announcement-bar-section");
  if (announcementBar) {
    etxScrollClass(
      window,
      announcementBar,
      document.body,
      60,
      "top",
      "up"
    );
  }*/

  // Header Navigation Scroll Behavior
  const header = document.querySelector("header");
  const htmlElement = document.documentElement;
  const announcementBar = document.querySelector(".announcement-bar-section");

  // Header-Höhe aus --hh (64px / 100px ab 1000px) statt offsetHeight → kein Forced Reflow
  const hhValue = (window.matchMedia('(min-width: 1000px)').matches ? 100 : 64) / 2;
  const announcementBreakpoint = 60; // ersetzt etxScrollClass(…, 60, "top", "up")

  let delay = 0;
  let lastScrollTop = window.scrollY;
  let isHeaderTranslated = false;
  let isHeaderTop = window.scrollY < hhValue;
  let isAnnouncementTop = window.scrollY < announcementBreakpoint;

  header?.classList.toggle("top", isHeaderTop);
  announcementBar?.classList.toggle("top", isAnnouncementTop);

  // Scroll Event Handler — RAF-throttled + passive, liest nur scrollY (kein Layout)
  let _scrollRafId = null;

  window.addEventListener("scroll", function () {
    if (_scrollRafId !== null) return;

    _scrollRafId = requestAnimationFrame(() => {
      const st = window.scrollY;

      const shouldTranslate =
        st > lastScrollTop &&
        st > delay &&
        !htmlElement.classList.contains("nav-show");

      if (header && shouldTranslate !== isHeaderTranslated) {
        // header.classList.toggle("translated", shouldTranslate);
        isHeaderTranslated = shouldTranslate;
      }

      const shouldBeTop = st < hhValue;
      if (header && shouldBeTop !== isHeaderTop) {
        header.classList.toggle("top", shouldBeTop);
        isHeaderTop = shouldBeTop;
      }

      const announcementTop = st < announcementBreakpoint;
      if (announcementBar && announcementTop !== isAnnouncementTop) {
        announcementBar.classList.toggle("top", announcementTop);
        isAnnouncementTop = announcementTop;
      }

      lastScrollTop = st <= 0 ? 0 : st;
      _scrollRafId = null;
    });
  }, { passive: true });

  function fadeInAll(elements, duration = 250) {
    elements.forEach(element => fadeIn(element, duration));
  }

  function hideAll(elements) {
    elements.forEach(el => instantHide(el));
  }

  // Header Navigation Toggle
  const headerNavToggle = document.querySelector(".HeaderNavToggle");
  if (headerNavToggle) {
    headerNavToggle.addEventListener("click", function () {
      if (htmlElement.classList.contains("nav-show")) {
        closeNav();
      } else {
        document.querySelectorAll(".HeaderSearch a").forEach(link => link.classList.remove("active"));

        htmlElement.classList.add("nav-show");

        document.querySelectorAll(".HeaderExpandable__inner").forEach(el => instantHide(el));

        const topnavs = document.querySelectorAll(".HeaderExpandable__topnav");
        fadeInAll([...topnavs]);
        refreshHeaderCardLinkSliders(topnavs);
      }
    });
  }

  // Back Button in Expandable Overview
  document.querySelectorAll(".HeaderExpandableOverview__back").forEach(backButton => {
    backButton.addEventListener("click", function () {
      if (header) {
        header.removeAttribute("data-open");
      }

      document.querySelectorAll(".HeaderExpandable__topnav a, .HeaderExpandable__topnav span").forEach(el => {
        el.classList.remove("active");
      });

      hideAll([...document.querySelectorAll(".HeaderExpandable__inner")]);

      const topnavs = document.querySelectorAll(".HeaderExpandable__topnav");
      fadeInAll([...topnavs]);
      refreshHeaderCardLinkSliders(topnavs);
    });
  });

  // Mobile Drawer Split Click Handler
  document.addEventListener("click", function (event) {
    const splitElement = event.target.closest("#MobileDrawer .Split");

    if (splitElement) {
      const columns = splitElement.dataset.columns;

      if (!splitElement.classList.contains("active")) {
        document.querySelectorAll("#MobileDrawer .Split").forEach(el => {
          el.classList.remove("active");
        });
        splitElement.classList.add("active");

        const productGrid = document.querySelector("#product-grid");
        if (productGrid) {
          if (columns == 2 && productGrid.classList.contains("c-1")) {
            productGrid.classList.remove("c-1");
            productGrid.classList.add("c-2");
          } else if (columns == 1 && productGrid.classList.contains("c-2")) {
            productGrid.classList.remove("c-2");
            productGrid.classList.add("c-1");
          }
        }
      }
    }
  });

  // Global Click Handler for Navigation and Popup
  document.addEventListener("click", function (event) {
    // Close navigation if click outside header
    if (
      !event.target.closest("header") &&
      htmlElement.classList.contains("nav-show")
    ) {
      closeNav();
    }

    // Close sizes popup if click outside
    const sizesPopup = document.querySelector("#SizesPopup");
    if (
      sizesPopup &&
      sizesPopup.style.display !== "none" &&
      !event.target.closest(".PopupInner, .togglePopup")
    ) {
      hide(sizesPopup);
      htmlElement.classList.remove("overflow-hidden");
      // handleKeydown ist hier nicht definiert → nur entfernen, wenn vorhanden
      if (typeof window.handleKeydown === "function") {
        document.removeEventListener("keydown", window.handleKeydown);
      }
    }
  });

  // Header Navigation and Search Click Handlers
  const navSearchElements = document.querySelectorAll(".HeaderNav a[data-nav-expandable], .HeaderNav span, .HeaderSearch a, .HeaderSearch span");
  navSearchElements.forEach(element => {
    element.addEventListener("click", function (event) {
      event.stopPropagation();
      event.preventDefault();

      const currentNav = this.dataset.navExpandable;
      const navIsOpen = htmlElement.classList.contains("nav-show");
      const samePanelIsOpen = header?.getAttribute("data-open") === currentNav;

      if (navIsOpen && samePanelIsOpen) {
        closeNav();
        return;
      }

      if (header) {
        header.setAttribute("data-open", currentNav);
      }

      navSearchElements.forEach(el => el.classList.remove("active"));
      document.querySelectorAll(".HeaderExpandable__inner").forEach(el => instantHide(el));

      this.classList.add("active");
      htmlElement.classList.add("nav-show");

      const expandableContents = document.querySelectorAll(
        `.HeaderExpandable__inner[data-nav-expandable-content="${currentNav}"]`
      );

      fadeInAll([...expandableContents]);
      refreshHeaderCardLinkSliders(expandableContents);
    });
  });

  // Header Top Navigation Click Handlers
  const topnavElements = document.querySelectorAll(".HeaderExpandable__topnav [data-nav-expandable]");
  topnavElements.forEach(element => {
    element.addEventListener("click", function (event) {
      event.stopPropagation();
      event.preventDefault();

      const currentNav = this.dataset.navExpandable;

      if (header) {
        header.setAttribute("data-open", currentNav);
      }

      navSearchElements.forEach(el => el.classList.remove("active"));
      document.querySelectorAll(".HeaderExpandable__inner").forEach(el => instantHide(el));

      this.classList.add("active");
      htmlElement.classList.add("nav-show");

      const expandableContents = document.querySelectorAll(
        `.HeaderExpandable__inner[data-nav-expandable-content="${currentNav}"]`
      );

      fadeInAll([...expandableContents]);
      refreshHeaderCardLinkSliders(expandableContents);
    });
  });

  // Header Language Button
  const languageButton = document.querySelector(".HeaderLanguage__button");
  if (languageButton) {
    languageButton.addEventListener("click", function () {
      const headerLanguage = this.closest(".HeaderLanguage");
      if (headerLanguage) {
        headerLanguage.classList.toggle("active");
      }
    });
  }

  // Trim Language Switcher Links
  document.querySelectorAll(".HeaderLanguage .lang_switcher_link").forEach(link => {
    link.textContent = link.textContent.split(" ")[0];
  });

  // Check for Hero Element (ohne scrollTop → kein Forced Reflow)
  if (document.querySelector(".Hero")) {
    htmlElement.classList.add("has-hero");
  }
});

// Window Resize Handler — nur bei Breitenänderung, debounced
// (Mobile feuert resize beim Ein-/Ausblenden der Adressleiste während des Scrollens)
let _lastWidth = window.innerWidth;
let _resizeTimer;
window.addEventListener("resize", function () {
  const w = window.innerWidth;
  if (w === _lastWidth) return;
  _lastWidth = w;

  clearTimeout(_resizeTimer);
  _resizeTimer = setTimeout(() => {
    if (typeof etxRecalcPathLengths === 'function') {
      etxRecalcPathLengths();
    }

    if (w > 1000 && document.documentElement.classList.contains("nav-show")) {
      closeNav();

      const headerMobileNav = document.querySelector(".HeaderMobileNav");
      if (headerMobileNav) hide(headerMobileNav);
    }
  }, 150);
});

// Window Load Handler
window.addEventListener("load", function () {
  if (typeof etxLazyLoad === 'function') {
    etxLazyLoad();
  }

  // eigener Task, damit der Load-Handler nicht blockiert
  setTimeout(startDeferredVideos, 0);
});

// Mobile Layout zweispaltig / einspaltig
document.addEventListener("click", function (event) {
  const clickedType = event.target.closest("#MobileLayout .Split");
  if (!clickedType) return;

  const columns = clickedType.dataset.columns;
  const productGrid = document.getElementById("product-grid");
  if (!productGrid) return;

  if (!clickedType.classList.contains("active")) {
    document
      .querySelectorAll("#MobileLayout .Split")
      .forEach(el => el.classList.remove("active"));

    clickedType.classList.add("active");

    if (columns == 2 && productGrid.classList.contains("mob-m:c-2")) {
      productGrid.classList.remove("mob-m:c-2");
      productGrid.classList.add("c-2");
    } else if (columns == 1 && productGrid.classList.contains("c-2")) {
      productGrid.classList.remove("c-2");
      productGrid.classList.add("mob-m:c-2");
    }
  }
});